import { getFeatureEnabledForCountry } from '../../../common/hooks/useGetFeatureEnabledForCountry';
import { HierarchicalLocation } from '../../../common/interfaces/entities';
import type { CompanyFormState, SelectedLocation } from './consts';

export const mapCompanyFormStateToPayload = (
  formData: CompanyFormState,
  user: { id: string; role: string }
) => {
  const { isHierarchicalLocationEnabled } = getFeatureEnabledForCountry(
    formData.CountryCode
  );

  return {
    name: formData.name,
    logo: formData.logo,
    website: formData.website || null,
    size: formData.size,
    IndustryId: formData.IndustryId,
    CountryCode: formData.CountryCode,
    brandName: formData.brandName || null,
    CityId: isHierarchicalLocationEnabled ? null : formData.CityId,
    LocationId: isHierarchicalLocationEnabled
      ? formData.locationDistrictId || formData.locationCityId
      : null,
    address: formData.address || null,
    customAttributes: {
      companyUser: [
        {
          UserId: user.id,
          role: user.role,
        },
      ],
    },
    acquisitionReferralCode: formData.acquisitionReferralCode,
    descriptionRaw: formData.descriptionRaw || null,
  };
};

export const convertLocationToOptions = (
  locations: Pick<HierarchicalLocation, 'id' | 'formattedName'>[]
) =>
  locations.map(location => ({
    value: location.id,
    label: location.formattedName,
  }));

export const isLocationCompatibleWithCountry = (
  countryCode?: string | null,
  selectedLocation?: SelectedLocation | null
) => {
  const normalizedCountryCode = (countryCode || '').toUpperCase();
  if (!normalizedCountryCode) return true;

  if (!selectedLocation?.countryCode) return true;

  return normalizedCountryCode === selectedLocation.countryCode.toUpperCase();
};
